module.exports = __webpack_public_path__ + "img/13.00f4d7bf.jpg";